import React from 'react';
import { useSelector } from 'react-redux';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';

// Copia de containers/Payment/PayPal/screens/components/PayPalCard.js.
const CARD_BG_FALLBACK = 'linear-gradient(143.5deg, #ffc43a 0%, #ffb33a 100%)';

const CARD_BG_ASSET_KEY = 'mdp_metodosdepago_tarjeta_asset_paypal';
const CARD_LOGO_ASSET_KEY =
  'mdp_metodosdepago_editarmdppaypal_tarjeta_logo_paypal';

export const PayPalCard = ({ email, action }) => {
  const assets = useSelector(store => store.asset);

  const cardBgAsset = assets?.[CARD_BG_ASSET_KEY] || '';
  const logoAsset = assets?.[CARD_LOGO_ASSET_KEY] || '';

  const backgroundImage = cardBgAsset
    ? `url(${cardBgAsset})`
    : CARD_BG_FALLBACK;

  return (
    <div
      className={`paypal-card ${action ? 'clickable' : ''}`}
      onClick={action}
      style={{ backgroundImage }}
    >
      {logoAsset && (
        <img className="paypal-card__logo" src={logoAsset} alt="PayPal" />
      )}

      <div className="paypal-card__email">{renderMaxLengthText(email, 47)}</div>
    </div>
  );
};

export default PayPalCard;
